export default "__VITE_PUBLIC_ASSET__448e853d__"